module.exports = __webpack_public_path__ + "static/img/menu2.b31f900.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/menu2.png
// module id = od2b
// module chunks = 11